import UserAvatar from '../../User/UserAvatar'
import tracker from '../../../components/tracker/publish'
import { getCurrentPage } from '../../common/index'

const eventTracker = () => {
  tracker.trackEvent('userevent', {
    type: 'Sidebar Widget Clicked',
    widget: 'notification',
    click_source: getCurrentPage()
  })
}

const FeaturedSidebar = ({ data }) => {
  const topic = data[0]
  const author = topic.firstPost.author

  return (
    <a className='box sidebar-notification notification' onClick={eventTracker} href={topic.url}>
      <div className='box__content box__pad'>
        <p className='notification-title'>
          <div class='notification-link'>
            { topic.title }
          </div>
        </p>
        <span class='thread-meta-item'>
          <UserAvatar
            user={author}
            extraClass='avatar avatar--S'
            showRank
          />
          <div className='notification-link'>
            <span className='thread-meta-item__date'>
              { topic.firstPost.relativeCreationDate }
            </span>
          </div>
        </span>
      </div>
    </a>
  )
}

export default FeaturedSidebar
